import React from "react";
import { SparklesIcon } from "@heroicons/react/24/solid";
import axios from 'axios'

const EndPoint = process.env.REACT_APP_API_ENDPOINT;

class Wizard extends React.Component {
  state = {
    open: false,
    query: "",
    mode: "summarise",
    output: "",
  };

  toggle = () => this.setState((s) => ({ open: !s.open }));

  close = () => this.setState({ open: false });

  handleProcess = async () => {
    const { query, mode } = this.state;
    const text = this.props.content;

    console.log(query)
    console.log(text)

    const res = await axios.post(
        `${EndPoint}/careplan/assistant`,
        {
          transcription: text,
          instruction: query,
        },
        { withCredentials: true }
      );

    this.setState({ output: res.data.success });
  };

  render() {
    const { open, query, mode, output } = this.state;

    return (
      <div className="relative inline-block">
        {/* Icon button */}
        <button
          type="button"
          onClick={this.toggle}
          className="rounded-full p-2 bg-sky-800 text-white"
          aria-label="Open wizard"
        >
          <SparklesIcon className="w-8 h-8" />
        </button>

        {/* Popup */}
        {open && (
          <>
            {/* Backdrop (click to close) */}
            <div
              className="fixed inset-0 z-40 flex items-center justify-center bg-black/40"
              onClick={this.close}
              aria-hidden="true"
            />

            <div className="-ml-[400px] z-50 absolute w-[1200px] h-[1200px] rounded-xl border border-slate-200 bg-white shadow-lg">
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <div className="text-xl text-center font-semibold text-slate-800">
                    Assistant
                  </div>
                  <button
                    type="button"
                    onClick={this.close}
                    className="ml-2 rounded-md px-2 py-1 text-xs text-slate-600 hover:bg-slate-100"
                    aria-label="Close"
                  >
                    ✕
                  </button>
                </div>

                {/* Input + Select */}
                <div className="mt-3 flex gap-2">
                  <input
                    className="w-1/2 rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-slate-200"
                    placeholder="Type here..."
                    value={query}
                    onChange={(e) => this.setState({ query: e.target.value })}
                  />

                  <select
                    className="w-1/2 rounded-lg border border-slate-200 bg-white px-2 py-2 text-sm outline-none focus:ring-2 focus:ring-slate-200"
                    value={mode}
                    onChange={(e) => this.setState({ mode: e.target.value })}
                  >
                    <option value="summarise">Summarise</option>
                    <option value="rewrite">Rewrite</option>
                    <option value="extract">Extract</option>
                  </select>
                </div>

                {/* Process button */}
                <button
                  type="button"
                  onClick={this.handleProcess}
                  className="mt-3 w-full rounded-lg bg-sky-800 hover:bg-sky-900 px-3 py-2 text-sm font-medium text-white active:scale-[0.99] transition"
                >
                  Process
                </button>

                {/* Textarea bottom */}
                <div className="mt-3">
                  <textarea
                    className="h-[1000px] w-full resize-none rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-slate-200"
                    placeholder="Output..."
                    value={output}
                    onChange={(e) => this.setState({ output: e.target.value })}
                  />
             
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default Wizard;
